import { render, staticRenderFns } from "./PesquisaIndexAtoAdministrativo.vue?vue&type=template&id=336cd7a4&scoped=true"
import script from "./PesquisaIndexAtoAdministrativo.vue?vue&type=script&lang=js"
export * from "./PesquisaIndexAtoAdministrativo.vue?vue&type=script&lang=js"
import style0 from "./PesquisaIndexAtoAdministrativo.vue?vue&type=style&index=0&id=336cd7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336cd7a4",
  null
  
)

export default component.exports